/* =========================================================
   MisjaSucho — global.js
   Vanilla, no build. Lightweight Web Components for menu /
   toasts / cart-add forms. Imports lazily via dynamic import.
   ========================================================= */

const T = window.theme || {};
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
const $  = (sel, root = document) => root.querySelector(sel);

// ---------- toast ----------
function toast(msg) {
  const wrap = document.getElementById('ToastLayer');
  if (!wrap) return;
  const node = document.createElement('div');
  node.className = 'toast';
  node.innerHTML = `<span class="tc"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span><span></span>`;
  node.querySelector('span:last-child').textContent = msg;
  wrap.appendChild(node);
  setTimeout(() => { node.style.opacity = '0'; node.style.transform = 'translateY(8px)'; }, 2400);
  setTimeout(() => node.remove(), 2800);
}
window.MSToast = toast;

// ---------- mobile sheet ----------
class MSheet extends HTMLElement {
  connectedCallback() {
    const open = () => { this.setAttribute('open', ''); document.body.style.overflow = 'hidden'; };
    const close = () => { this.removeAttribute('open'); document.body.style.overflow = ''; };
    const trigger = $('[data-mobile-trigger]');
    if (trigger) trigger.addEventListener('click', open);
    this.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', close));
    this.querySelector('.scrim')?.addEventListener('click', close);
    this.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
  }
}
customElements.define('ms-sheet', MSheet);

// ---------- header cart badge updater ----------
function setCartCount(n) {
  $$('.cart-count').forEach(el => {
    if (n > 0) { el.textContent = n; el.hidden = false; }
    else { el.hidden = true; }
  });
}

// ---------- intercept add-to-cart forms ----------
async function addToCartFromForm(form) {
  const btn = form.querySelector('[type="submit"]');
  if (btn) btn.setAttribute('aria-disabled', 'true');
  try {
    const data = new FormData(form);
    const res = await fetch(`${T.rootUrl}cart/add.js`, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
    });
    if (!res.ok) throw new Error('add failed');
    const items = await res.json();
    const cart = await (await fetch(`${T.rootUrl}cart.js`)).json();
    setCartCount(cart.item_count);
    const name = items.product_title || (items.items && items.items[0]?.product_title) || 'produkt';
    toast(`Dodano: ${name}`);
    document.dispatchEvent(new CustomEvent('ms:cart:updated', { detail: cart }));
  } catch (e) {
    console.warn('[cart]', e);
    toast('Nie udało się dodać produktu');
  } finally {
    if (btn) btn.removeAttribute('aria-disabled');
  }
}

document.addEventListener('submit', (e) => {
  const f = e.target.closest('form[data-product-form]');
  if (!f) return;
  e.preventDefault();
  flyToCart(f);
  addToCartFromForm(f);
});

// ---------- fly-to-cart animation ----------
function flyToCart(form) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Locate source: product image, falling back to the button itself
  const container = form.closest('.pcard, .pdp, .card, .land-hero') || form.parentElement;
  const srcEl = container?.querySelector('.pdp-main, .lh-art, .ph') || form.querySelector('[type=submit]') || form;
  const srcImg = srcEl?.querySelector('img');

  // Locate target: the cart icon button in the sticky header
  const targetEl = document.querySelector('.hdr a[href*="/cart"], .hdr .icon-btn[aria-label*="oszyk" i]');
  if (!srcEl || !targetEl) return;

  const s = srcEl.getBoundingClientRect();
  const t = targetEl.getBoundingClientRect();
  if (s.width === 0 || t.width === 0) return;

  // Clone a small flyer (capped to 120px so big PDP images don't dominate the screen)
  const maxSize = 120;
  const scale = Math.min(1, maxSize / Math.max(s.width, s.height));
  const w = s.width * scale, h = s.height * scale;
  const startX = s.left + (s.width - w) / 2;
  const startY = s.top + (s.height - h) / 2;

  const flyer = document.createElement('div');
  flyer.setAttribute('aria-hidden', 'true');
  Object.assign(flyer.style, {
    position: 'fixed', left: startX + 'px', top: startY + 'px',
    width: w + 'px', height: h + 'px', zIndex: 9999, pointerEvents: 'none',
    borderRadius: 'var(--radius)', overflow: 'hidden',
    backgroundColor: 'var(--accent-soft, #eef2ea)',
    boxShadow: '0 12px 36px -8px rgba(0,0,0,.35)',
    willChange: 'transform, opacity, border-radius',
  });
  if (srcImg && srcImg.complete) {
    const img = new Image();
    img.src = srcImg.currentSrc || srcImg.src;
    Object.assign(img.style, { width: '100%', height: '100%', objectFit: 'cover', display: 'block' });
    flyer.appendChild(img);
  }
  document.body.appendChild(flyer);

  // End point: center of cart icon
  const endCx = t.left + t.width / 2;
  const endCy = t.top + t.height / 2;
  const startCx = startX + w / 2;
  const startCy = startY + h / 2;
  const dx = endCx - startCx;
  const dy = endCy - startCy;

  // Mid-point biased up & towards target — gives the arc feel
  const midDx = dx * 0.55;
  const midDy = Math.min(dy * 0.2, -80); // lift up by at least 80px

  const dur = Math.min(900, 500 + Math.hypot(dx, dy) * 0.35);

  const anim = flyer.animate([
    { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, borderRadius: '12px' },
    { transform: `translate(${midDx}px, ${midDy}px) scale(.55) rotate(-12deg)`, opacity: .95, borderRadius: '40%', offset: .55 },
    { transform: `translate(${dx}px, ${dy}px) scale(.12) rotate(-22deg)`, opacity: 0, borderRadius: '50%' },
  ], { duration: dur, easing: 'cubic-bezier(.55, 0, .55, 1)', fill: 'forwards' });

  anim.onfinish = () => { flyer.remove(); bumpCart(); };
  anim.oncancel  = () => { flyer.remove(); };
}

function bumpCart() {
  const btn = document.querySelector('.hdr a[href*="/cart"], .hdr .icon-btn[aria-label*="oszyk" i]');
  const badge = btn?.querySelector('.cart-count');
  const target = badge && !badge.hidden ? badge : btn;
  if (!target || !target.animate) return;
  target.animate([
    { transform: 'scale(1)' },
    { transform: 'scale(1.35)' },
    { transform: 'scale(1)' },
  ], { duration: 380, easing: 'cubic-bezier(.4, 1.5, .6, 1)' });
}

// ---------- accordions handled by <details>; nothing needed ----------

// Quiz / NFZ scripts are injected directly by their sections via asset_url.

// ---------- product page: variant switcher ----------
class VariantSelector extends HTMLElement {
  selectedVariant() {
    const options = this.optionInputs
      .filter(el => el.type !== 'radio' || el.checked)
      .sort((a, b) => +a.dataset.optionIndex - +b.dataset.optionIndex)
      .map(el => el.value);
    return this.product.variants.find(v =>
      v.options.every((o, i) => o === options[i])
    );
  }
  currentOptions() {
    return this.optionInputs
      .filter(el => el.type !== "radio" || el.checked)
      .sort((a, b) => +a.dataset.optionIndex - +b.dataset.optionIndex)
      .map(el => el.value);
  }
  // Not every print exists in every size. An impossible combination snaps to the
  // closest real variant, keeping the value the customer just picked.
  closestVariant(changedEl) {
    if (!changedEl) return null;
    const idx = +changedEl.dataset.optionIndex;
    const cur = this.currentOptions();
    const score = v => v.options.reduce((n, o, i) => n + (o === cur[i] ? 1 : 0), 0) + (v.available ? 0.5 : 0);
    return this.product.variants.filter(v => v.options[idx] === changedEl.value).sort((a, b) => score(b) - score(a))[0] || null;
  }
  applyOptions(options) {
    this.optionInputs.forEach(el => { const i = +el.dataset.optionIndex; if (options[i] != null) el.value = options[i]; });
    this.querySelectorAll(".size-btn").forEach(b => b.classList.toggle("sel", options[+b.dataset.optionIndex] === b.dataset.value));
  }
  // Strike through sizes that do not exist for the current choice; dropdown entries list what they come in.
  markAvailability() {
    const cur = this.currentOptions();
    const variants = this.product.variants;
    const exists = (idx, val) => variants.some(v => v.options.every((o, i) => (i === idx ? o === val : o === cur[i])));
    this.querySelectorAll(".size-btn").forEach(b => b.classList.toggle("is-unavailable", !exists(+b.dataset.optionIndex, b.dataset.value)));
    const twoOptions = this.product.options.length === 2;
    this.querySelectorAll("select[data-option-index] option").forEach(o => {
      if (o.dataset.label == null) o.dataset.label = o.textContent;
      const idx = +o.parentElement.dataset.optionIndex;
      if (exists(idx, o.value)) { o.textContent = o.dataset.label; return; }
      const other = 1 - idx;
      const alt = twoOptions ? [...new Set(variants.filter(v => v.options[idx] === o.value).map(v => v.options[other].split(" · ")[0]))] : [];
      o.textContent = o.dataset.label + (alt.length ? " — dostępne: " + alt.join(", ") : " (inna konfiguracja)");
    });
  }
  update(changedEl) {
    let v = this.selectedVariant();
    if (!v) { v = this.closestVariant(changedEl); if (v) this.applyOptions(v.options); }
    this.markAvailability();
    const idInput = $('[name="id"]', this);
    const priceEl = $('[data-variant-price]', this);
    const cmpEl = $('[data-variant-compare]', this);
    const btn = $('[data-add-btn]', this);
    if (!v) {
      if (btn) { btn.disabled = true; const lbl = btn.querySelector('[data-add-label]'); if (lbl) lbl.textContent = 'Niedostępne'; }
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = formatMoney(v.price);
    if (cmpEl) cmpEl.textContent = v.compare_at_price && v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
    // Sync the sticky-atc price (outside this <variant-selector>)
    document.querySelectorAll('[data-sticky-price]').forEach(el => { el.textContent = formatMoney(v.price); });
    this._unitPrice = v.price;
    this.recalcTotal();
    if (btn) {
      btn.disabled = !v.available;
      const lbl = btn.querySelector('[data-add-label]');
      if (lbl) lbl.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState({}, '', url);
    this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
  }
  recalcTotal() {
    const qtyEl = $('[name="quantity"]', this);
    const totalEl = $('[data-line-total]', this);
    if (!qtyEl || !totalEl || this._unitPrice == null) return;
    const qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
    totalEl.textContent = formatMoney(this._unitPrice * qty);
  }
  connectedCallback() {
    this.product = JSON.parse(this.querySelector('[data-product-json]')?.textContent || 'null');
    if (!this.product) return;
    this.optionInputs = $$('input[data-option-index], select[data-option-index]', this);
    this.optionInputs.forEach(el => el.addEventListener('change', () => this.update(el)));
    const qtyEl = $('[name="quantity"]', this);
    if (qtyEl) qtyEl.addEventListener('change', () => this.recalcTotal());
    this.update();
  }
}
customElements.define('variant-selector', VariantSelector);

function formatMoney(cents) {
  const v = (cents / 100).toFixed(2).replace('.', ',');
  return `${v} zł`;
}
window.MSMoney = formatMoney;

// ---------- sticky add-to-cart bar (mobile PDP) ----------
(function () {
  const bar = document.getElementById('StickyATC');
  const mainBtn = document.querySelector('[data-add-btn]');
  if (!bar || !mainBtn) return;

  // Show the bar only when the main button has scrolled out of view
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
    io.observe(mainBtn);
  }

  // Tapping the sticky button submits the real product form so size /
  // subscription / qty selections are preserved. Skip the fly-to-cart
  // animation since the source image isn't visible at this scroll position.
  bar.querySelector('[data-sticky-atc-btn]')?.addEventListener('click', async (e) => {
    e.preventDefault();
    const form = document.querySelector('form[data-product-form]');
    if (!form) return;
    await addToCartFromForm(form);
    bumpCart();
  });
})();

// ---------- pdp quantity stepper ----------
document.addEventListener('click', (e) => {
  const stepper = e.target.closest('.qty button');
  if (!stepper) return;
  const wrap = stepper.parentElement;
  const input = wrap.querySelector('input');
  if (!input) return;
  const cur = parseInt(input.value, 10) || 1;
  const min = parseInt(input.min || '1', 10);
  const next = stepper.dataset.step === '-1' ? Math.max(min, cur - 1) : cur + 1;
  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// ---------- size selector toggles hidden option input ----------
document.addEventListener('click', (e) => {
  const b = e.target.closest('.size-btn');
  if (!b) return;
  const group = b.parentElement;
  group.querySelectorAll('.size-btn').forEach(x => x.classList.remove('sel'));
  b.classList.add('sel');
  const input = document.querySelector(`input[data-option-index="${b.dataset.optionIndex}"]`);
  if (input) { input.value = b.dataset.value; input.dispatchEvent(new Event('change', { bubbles: true })); }
});

// ---------- subscribe toggle on PDP/bundle ----------
document.addEventListener('click', (e) => {
  const box = e.target.closest('[data-subscribe-toggle]');
  if (!box) return;
  // Don't toggle when the click landed inside the cadence slider area.
  if (e.target.closest('[data-cadence-area]')) return;
  const on = box.classList.toggle('sel');
  const sub = document.querySelector('input[name="properties[Subskrypcja]"]');
  if (sub) sub.value = on ? `Tak (−${T.subscriptionDiscountPct}%)` : '';
  // Sync the cadence hidden field so it's only set when subscription is on.
  const slider = box.querySelector('[data-cadence-input]');
  const cad = document.querySelector('input[data-cadence-hidden]');
  if (cad) cad.value = on && slider ? `${slider.value} dni` : '';
});

// ---------- subscription cadence: slider <-> number input two-way sync ----------
function syncCadence(box, raw) {
  const slider = box.querySelector('[data-cadence-input]');
  const num    = box.querySelector('[data-cadence-number]');
  if (!slider || !num) return;
  const min = parseInt(slider.min, 10) || 1;
  const max = parseInt(slider.max, 10) || 90;
  let v = parseInt(raw, 10);
  if (isNaN(v)) return;
  if (v < min) v = min;
  if (v > max) v = max;
  if (String(slider.value) !== String(v)) slider.value = v;
  if (String(num.value)    !== String(v)) num.value    = v;
  const bodyDays = box.querySelector('[data-cadence-body-days]');
  if (bodyDays) bodyDays.textContent = v;
  if (box.classList.contains('sel')) {
    const cad = document.querySelector('input[data-cadence-hidden]');
    if (cad) cad.value = v + ' dni';
  }
}
document.addEventListener('input', (e) => {
  const source = e.target.closest('[data-cadence-input], [data-cadence-number]');
  if (!source) return;
  const box = source.closest('[data-subscribe-toggle]');
  if (box) syncCadence(box, source.value);
});
// Clamp typed values when the number input loses focus.
document.addEventListener('blur', (e) => {
  const num = e.target.closest('[data-cadence-number]');
  if (!num) return;
  const box = num.closest('[data-subscribe-toggle]');
  if (box) syncCadence(box, num.value || num.min);
}, true);
// Click a tick number under the slider → snap to that value.
document.addEventListener('click', (e) => {
  const tick = e.target.closest('[data-cadence-tick]');
  if (!tick) return;
  const box = tick.closest('[data-subscribe-toggle]');
  if (box) syncCadence(box, tick.dataset.cadenceTick);
});

// ---------- send subscription intent to MisjaSucho-HelperApp on add-to-cart ----------
// Fire-and-forget: HelperApp records the intent so it can attribute the
// subscription cleanly when the orders/create webhook lands. Never blocks
// add-to-cart even if the helper is down.
document.addEventListener('submit', (e) => {
  const form = e.target.closest('form[action$="/cart/add"], form[data-product-form]');
  if (!form) return;
  const box = form.querySelector('[data-subscribe-toggle].sel') ||
              document.querySelector('[data-subscribe-toggle].sel');
  if (!box) return;
  const helper = (T && T.helperAppUrl) || '';
  if (!helper) return;
  const variantInput = form.querySelector('input[name="id"]');
  const qtyInput     = form.querySelector('input[name="quantity"]');
  const slider       = box.querySelector('[data-cadence-input]');
  const payload = {
    shop:         box.dataset.shop,
    product_id:   box.dataset.productId,
    variant_id:   variantInput ? variantInput.value : box.dataset.variantId,
    quantity:     qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
    cadence:      slider ? parseInt(slider.value, 10) : 30,
    discount_pct: T.subscriptionDiscountPct || 0,
    ts:           Date.now(),
  };
  try {
    fetch(helper.replace(/\/+$/,'') + '/api/intent', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {}
});

// ---------- cart line update (full-page cart) ----------
document.addEventListener('change', async (e) => {
  const input = e.target.closest('input[data-cart-qty]');
  if (!input) return;
  const key = input.dataset.cartQty;
  const qty = Math.max(0, parseInt(input.value, 10) || 0);
  const res = await fetch(`${T.rootUrl}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: qty }),
  });
  if (res.ok) location.reload();
});
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-cart-remove]');
  if (!b) return;
  e.preventDefault();
  await fetch(`${T.rootUrl}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: b.dataset.cartRemove, quantity: 0 }),
  });
  location.reload();
});

// ---------- attribute icon tooltips (tap to toggle on mobile) ----------
document.addEventListener('click', (e) => {
  const icon = e.target.closest('.attr-icon');
  // Close any previously-open tooltip (so only one shows at a time)
  document.querySelectorAll('.attr-icon.show').forEach(el => {
    if (el !== icon) el.classList.remove('show');
  });
  if (icon) {
    e.preventDefault();
    e.stopPropagation();
    icon.classList.toggle('show');
  }
});
// Close any open tooltip on Escape or scroll
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') document.querySelectorAll('.attr-icon.show').forEach(el => el.classList.remove('show'));
});
window.addEventListener('scroll', () => {
  document.querySelectorAll('.attr-icon.show').forEach(el => el.classList.remove('show'));
}, { passive: true });

// ---------- collection filter form auto-submit ----------
class FilterForm extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', () => {
      clearTimeout(this._t);
      this._t = setTimeout(() => this.querySelector('form').submit(), 250);
    });
  }
}
customElements.define('filter-form', FilterForm);

// ---------- pickup-point picker (InPost Paczkomat + ORLEN Paczka) ----------
// A checkbox reveals a carrier-tabbed map. The chosen point is written to cart
// attributes (which become the order's note_attributes); the MisjaSucho Helper
// App overwrites the order shipping address from them on orders/create.
// When the box is checked, a point is REQUIRED — the checkout button is gated.
const _assetCache = {};
function loadAsset(tag, attrs) {
  const key = tag + '|' + (attrs.src || attrs.href);
  if (_assetCache[key]) return _assetCache[key];
  _assetCache[key] = new Promise((resolve, reject) => {
    const el = document.createElement(tag);
    Object.assign(el, attrs);
    el.onload = () => resolve();
    el.onerror = () => reject(new Error('load failed: ' + (attrs.src || attrs.href)));
    document.head.appendChild(el);
  });
  return _assetCache[key];
}

class PickupPoints extends HTMLElement {
  connectedCallback() {
    // Moving the element between the desktop/mobile slots re-fires
    // connectedCallback; initialise only once so listeners and the config
    // fetch aren't duplicated and the selected state is preserved.
    if (this._initialized) return;
    this._initialized = true;
    this.checkbox = this.querySelector('[data-pickup-checkbox]');
    this.body     = this.querySelector('[data-pickup-body]');
    this.picker   = this.querySelector('[data-pickup-picker]');
    this.summary  = this.querySelector('[data-pickup-summary]');
    this.mapBox   = this.querySelector('[data-pickup-map]');
    this.msgBox   = this.querySelector('[data-pickup-msg]');
    this.warning  = this.querySelector('[data-pickup-warning]');
    this.checkoutBtn = document.querySelector('[data-checkout-btn]');
    this.carrier = 'inpost';
    this.mounted = {};

    // Restore any previously-selected point (set server-side from cart attributes).
    try { this.point = JSON.parse(this.dataset.selected || 'null'); }
    catch (_) { this.point = null; }

    // Defaults from theme settings (data-*); the Helper App backend config
    // (/api/pickup/config) overrides these in loadConfig() and is the source
    // of truth when a Helper App URL is configured.
    this.inpostToken  = this.dataset.inpostToken || '';
    this.orlenToken   = this.dataset.orlenToken  || '';
    this.inpostConfig = this.dataset.inpostConfig || 'parcelcollect';
    this.inpostSandbox = this.dataset.inpostSandbox === '1';
    this.orlenUrl     = this.dataset.orlenUrl || '';
    this.anyCarrier   = !!(this.inpostToken || this.orlenToken);

    this.checkbox.addEventListener('change', () => this.onToggle());
    this.querySelectorAll('[data-carrier]').forEach(t =>
      t.addEventListener('click', () => this.switchCarrier(t.dataset.carrier)));
    const changeBtn = this.querySelector('[data-pickup-change]');
    if (changeBtn) changeBtn.addEventListener('click', () => this.editPoint());

    // Block checkout while the gate is on. The button is only aria-disabled
    // (not natively disabled) so it still shows the not-allowed cursor and the
    // title tooltip — so we must stop the click/submit ourselves.
    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', (e) => {
        if (this.checkoutBtn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); e.stopPropagation(); }
      });
      const form = this.checkoutBtn.form;
      if (form) form.addEventListener('submit', (e) => {
        if (this.checkoutBtn.getAttribute('aria-disabled') === 'true') e.preventDefault();
      });
    }

    // InPost Geowidget dispatches a DOM event named by its `onpoint` attribute.
    this._inpostEvt = 'ms-inpost-point';
    document.addEventListener(this._inpostEvt, (e) => this.onInpostPoint(e.detail));
    // ORLEN map posts the chosen point via window.postMessage.
    window.addEventListener('message', (e) => this.onOrlenMessage(e));

    this.configReady = this.loadConfig();
    // If the cart loads with the box already ticked (a point was remembered),
    // reveal the picker + map right away instead of an empty/collapsed section.
    if (this.checkbox.checked) {
      this.body.removeAttribute('hidden');
      this.showPicker();
    }
    this.updateGate();
  }

  // Show the carrier tabs + map (hide the selected-point summary) and mount the
  // active carrier. mountCarrier waits for configReady so tokens are loaded.
  showPicker() {
    if (this.summary) this.summary.setAttribute('hidden', '');
    if (this.picker) this.picker.removeAttribute('hidden');
    this.mountCarrier(this.carrier);
  }

  // Pull tokens from the Helper App backend (Pickup points tab) when a Helper
  // App URL is set; falls back silently to the theme-settings data-* values.
  async loadConfig() {
    const helper = ((window.theme && theme.helperAppUrl) || '').replace(/\/+$/, '');
    if (helper) {
      try {
        const r = await fetch(helper + '/api/pickup/config', { headers: { Accept: 'application/json' } });
        if (r.ok) {
          const cfg = await r.json();
          if (cfg && cfg.enabled === false) { this.disableUi(); return; }
          if (cfg && cfg.inpost) {
            if (cfg.inpost.token) this.inpostToken = cfg.inpost.token;
            if (typeof cfg.inpost.sandbox === 'boolean') this.inpostSandbox = cfg.inpost.sandbox;
            if (cfg.inpost.config) this.inpostConfig = cfg.inpost.config;
          }
          if (cfg && cfg.orlen) {
            if (cfg.orlen.token) this.orlenToken = cfg.orlen.token;
            if (cfg.orlen.url) this.orlenUrl = cfg.orlen.url;
          }
        }
      } catch (_) { /* keep theme-settings fallback */ }
    }
    this.anyCarrier = !!(this.inpostToken || this.orlenToken);
    this.updateGate();
  }

  // Backend master-switch is off — hide the picker and never gate checkout.
  disableUi() {
    this.anyCarrier = false;
    this.style.display = 'none';
    if (this.checkbox) this.checkbox.checked = false;
    if (this.point) this.clearPoint();
    this.updateGate();
  }

  onToggle() {
    if (this.checkbox.checked) {
      this.body.removeAttribute('hidden');
      this.showPicker();
    } else {
      this.body.setAttribute('hidden', '');
      if (this.point) this.clearPoint();
    }
    this.updateGate();
  }

  switchCarrier(carrier) {
    this.carrier = carrier;
    this.querySelectorAll('[data-carrier]').forEach(t =>
      t.classList.toggle('sel', t.dataset.carrier === carrier));
    this.mountCarrier(carrier);
  }

  editPoint() {
    this.showPicker();
  }

  showMsg(text) {
    if (!this.msgBox) return;
    this.msgBox.textContent = text;
    this.msgBox.hidden = !text;
  }

  async mountCarrier(carrier) {
    // Make sure backend tokens have loaded before mounting a map.
    if (this.configReady) { try { await this.configReady; } catch (_) {} }
    // Hide all mounted maps, show the requested one.
    Object.entries(this.mounted).forEach(([k, el]) => { el.hidden = k !== carrier; });
    this.showMsg('');
    if (this.mounted[carrier]) return;
    try {
      if (carrier === 'inpost') await this.mountInpost();
      else await this.mountOrlen();
    } catch (err) {
      this.showMsg(this.dataset.lUnavailable || 'Wybór punktu jest chwilowo niedostępny.');
    }
  }

  async mountInpost() {
    if (!this.inpostToken) { this.showMsg(this.dataset.lUnavailable); throw new Error('no inpost token'); }
    const host = this.inpostSandbox
      ? 'https://sandbox-easy-geowidget-sdk.easypack24.net'
      : 'https://geowidget.inpost.pl';
    await loadAsset('link', { rel: 'stylesheet', href: host + '/inpost-geowidget.css' });
    await loadAsset('script', { src: host + '/inpost-geowidget.js', defer: true });
    const w = document.createElement('inpost-geowidget');
    w.setAttribute('token', this.inpostToken);
    w.setAttribute('language', 'pl');
    w.setAttribute('config', this.inpostConfig || 'parcelcollect');
    w.setAttribute('onpoint', this._inpostEvt);
    w.className = 'pickup-geowidget';
    this.mapBox.appendChild(w);
    this.mounted.inpost = w;
  }

  async mountOrlen() {
    if (!this.orlenToken) { this.showMsg(this.dataset.lUnavailable); throw new Error('no orlen token'); }
    const base = (this.orlenUrl || 'https://mapa.orlenpaczka.pl').replace(/\/+$/, '');
    const sep = base.includes('?') ? '&' : '?';
    const frame = document.createElement('iframe');
    frame.src = base + sep + 'token=' + encodeURIComponent(this.orlenToken);
    frame.className = 'pickup-geowidget';
    frame.title = 'ORLEN Paczka';
    frame.loading = 'lazy';
    this.mapBox.appendChild(frame);
    this.mounted.orlen = frame;
  }

  // ─── point handlers ──────────────────────────────────────────────
  onInpostPoint(d) {
    if (!d || this.carrier !== 'inpost') return;
    const det = d.address_details || {};
    this.selectPoint({
      carrier: 'inpost',
      code: d.name || '',
      name: d.name || '',
      street: det.street || '',
      building: det.building_number || '',
      city: det.city || '',
      post_code: det.post_code || '',
      line1: (d.address && d.address.line1) || '',
      line2: (d.address && d.address.line2) || '',
    });
  }

  onOrlenMessage(e) {
    if (this.carrier !== 'orlen') return;
    let p = e && e.data;
    if (!p || typeof p !== 'object') return;
    // Tolerant parse — ORLEN's payload may nest the point or vary field names.
    p = p.point || p.pudo || p.detail || p;
    const code = p.id || p.code || p.name || p.pointId;
    if (!code) return;
    this.selectPoint({
      carrier: 'orlen',
      code: String(code),
      name: p.description || p.name || String(code),
      street: p.street || p.address || p.addressLine || '',
      building: p.building || p.houseNumber || '',
      city: p.city || p.town || '',
      post_code: p.postCode || p.post_code || p.zip || p.postcode || '',
      line1: p.address || '',
      line2: '',
    });
  }

  // ─── persistence + UI ────────────────────────────────────────────
  async selectPoint(point) {
    this.point = point;
    const method = point.carrier === 'inpost' ? 'Paczkomat InPost' : 'Punkt ORLEN Paczka';
    const streetLine = [point.street, point.building].filter(Boolean).join(' ').trim();
    const cityLine = [point.post_code, point.city].filter(Boolean).join(' ').trim();
    const readable = [streetLine, cityLine].filter(Boolean).join(', ');
    await this.save({
      'Sposób dostawy': method,
      'Punkt odbioru': point.code,
      'Adres punktu': readable,
      '_pickup_point': JSON.stringify(point),
    });
    // Update summary UI without a reload.
    this.summary.querySelector('[data-pickup-name]').textContent = method + ' ' + point.code;
    this.summary.querySelector('[data-pickup-addr]').textContent = readable;
    this.picker.setAttribute('hidden', '');
    this.summary.removeAttribute('hidden');
    this.classList.add('has-point');
    this.updateGate();
  }

  async clearPoint() {
    this.point = null;
    await this.save({
      'Sposób dostawy': '',
      'Punkt odbioru': '',
      'Adres punktu': '',
      '_pickup_point': '',
    });
    this.classList.remove('has-point');
    if (this.summary) this.summary.setAttribute('hidden', '');
    if (this.picker) this.picker.removeAttribute('hidden');
  }

  save(attributes) {
    const url = this.dataset.cartUpdate || (window.theme && theme.cartUpdateUrl) || '/cart/update.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes }),
    }).catch(() => {});
  }

  updateGate() {
    if (!this.checkoutBtn) return;
    // Block checkout only when the customer asked for pickup, a carrier is
    // actually available, and no point has been chosen yet. Use aria-disabled
    // (not the native disabled attribute) so the not-allowed cursor and the
    // title tooltip still show; the click/submit guards do the actual blocking.
    const blocked = this.checkbox.checked && this.anyCarrier && !this.point;
    this.checkoutBtn.disabled = false;
    this.checkoutBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    const msg = this.dataset.lRequired || 'Wybierz punkt odbioru.';
    if (blocked) {
      // Show the reason as a styled tooltip over the (visually) disabled button.
      this.checkoutBtn.setAttribute('data-tooltip', msg);
      this.checkoutBtn.setAttribute('aria-label', msg);
    } else {
      this.checkoutBtn.removeAttribute('data-tooltip');
      this.checkoutBtn.removeAttribute('aria-label');
    }
    this.checkoutBtn.removeAttribute('title');
    if (this.warning) this.warning.hidden = true;
  }
}
customElements.define('pickup-points', PickupPoints);

// Desktop (2-column cart): the checkbox sits in the order summary above the
// checkout button, while the body (hint + carrier tabs + map) stays under the
// products. Mobile (single column): the whole card stays together in the
// summary. We relocate one instance between slots — moving the toggle in/out
// of the element — so there's never a duplicate.
function relocatePickup() {
  const el = document.querySelector('pickup-points');
  if (!el) return;
  const toggle = el.querySelector('.pickup-toggle') || document.querySelector('.pickup-toggle');
  const desktop = window.matchMedia('(min-width: 981px)').matches;
  const bodySlot   = document.querySelector('[data-pickup-slot="desktop"]');
  const toggleSlot = document.querySelector('[data-pickup-slot="toggle"]');
  const mobileSlot = document.querySelector('[data-pickup-slot="mobile"]');
  if (desktop) {
    if (toggle && toggleSlot && toggle.parentElement !== toggleSlot) toggleSlot.appendChild(toggle);
    if (bodySlot && el.parentElement !== bodySlot) bodySlot.appendChild(el);
  } else {
    if (toggle && el.firstChild !== toggle) el.insertBefore(toggle, el.firstChild);
    if (mobileSlot && el.parentElement !== mobileSlot) mobileSlot.appendChild(el);
  }
}
relocatePickup();
try { window.matchMedia('(min-width: 981px)').addEventListener('change', relocatePickup); }
catch (_) { window.addEventListener('resize', relocatePickup); }
